<template lang="pug">
.container-fullscreen-fixed(id="LayoutEditorFullScreen-container" ref="page")
  .top-bar
    .left-column(:style='getLeftColumnStyle()')
      p(v-if='playListWithContentSimple && playListWithContentSimple.name')
        el-form(:inline='true', size="mini")
          el-form-item(:label='$t("Layout:")')
            span &nbsp; {{ playListWithContentSimple.name }}
          el-form-item(:label='$t("Width:")')
            el-input-number(id="LayoutEditorFullScreen-layoutWidthInput" v-model='playListWithContentSimple.playListLayoutWidth', @blur='patchLayout')
            span px
          el-form-item(:label='$t("Height:")')
            el-input-number(id="LayoutEditorFullScreen-layoutHeightInput" v-model='playListWithContentSimple.playListLayoutHeight', @blur='patchLayout')
            span px
      p(v-else)
        span {{ $t('rendering layout...')}}
    .right-column(:style='getRightColumnStyle()')
      el-button.first(id="LayoutEditorFullScreen-closeButton" type="text", @click="$emit('close')")
        font-awesome-icon(icon="window-minimize")
  .container-stage
    .left-column(
      ref="viewportcontainer",
      @click.self='selectedLayer = undefined',
      :style='getLeftColumnStyle()'
    )
      .viewport(
        :style="getVieportStyle()",
        @click.self='selectedLayer = undefined',
      )
        Viewport(
          ref='viewport',
          v-if='playListWithContentSimple',
          :playListWithContentSimple='playListWithContentSimple',
          :selectedLayer='selectedLayer',
          :viewParams='viewParams',
          :scale='scale',
          :hiddenLayers='hiddenLayers',
          :lockedLayers='lockedLayers',
          @selectLayer='selectLayerInVieport',
          @boxResized='boxResizedEventHandler',
          id="LayoutEditorFullScreen-viewport"
        )
        Guides(v-if='viewParams.showGuides', :guides='guides', :viewportHeight='playListWithContentSimple.playListLayoutHeight * scale')
    .divider(draggable, @drag='dragDivider', @dblclick='toggleColumns')
    .right-column(
      @click.self='selectedLayer = undefined',
      :style='getRightColumnStyle()'
    )
      LayersPalette(
        v-if='playListWithContentSimple && ($refs.page.offsetWidth - divider.value >= viewParams.minimumRightColumnWidth)',
        @toggleLayerHidden='toggleLayerHidden',
        @toggleLayerLocked='toggleLayerLocked',
        @loadData='loadData',
        @selectLayer='selectLayerInLayersPalette',
        @redrawBoundingBox='redrawBoundingBox',
        :layers='playListWithContentSimple.PlayListItems',
        :hiddenLayers='hiddenLayers',
        :lockedLayers='lockedLayers',
        :selectedLayer='selectedLayer',
        :playListWithContentSimple='playListWithContentSimple',
        id="LayoutEditorFullScreen-layoutPallete"
      )
  .status-bar
    el-form(:inline='true', size="mini")
      el-form-item(:label='$t("Snap to borders:")')
        el-checkbox(id="LayoutEditorFullScreen-snapToBordersCheckbox" v-model='viewParams.snapToGuides', @change='recalculateGuides')
      el-form-item(:label='$t("Snap distance px:")')
        el-input-number(id="LayoutEditorFullScreen-snapDistance" v-model='viewParams.snapDistance', :disabled='!viewParams.snapToGuides')
      el-form-item(:label='$t("Show guides:")')
        el-checkbox(id="LayoutEditorFullScreen-showGuidesCheckbox" v-model='viewParams.showGuides', @change='recalculateGuides', :disabled='!viewParams.snapToGuides')
      el-form-item(:label='$t("Dim not selected:")')
        el-checkbox(id="LayoutEditorFullScreen-dimsNotSelectedCheckbox" v-model='viewParams.dimunfocused')
      el-form-item(:label='$t("High quality preview:")')
        el-checkbox(id="LayoutEditorFullScreen-highQualityPreviewCheckbox" v-model='viewParams.highQualityPreview')
    span.label(id="LayoutEditorFullScreen-selectedLayerLabel" v-if='selectedLayer')
      span.label.separator {{ $t("|") }}
      //- span.label
      //-   img(:src='getThumbnailPath(selectedLayer.File)', style='height:15px; margin-top:2px')
      span.label
        MediumIcon(:medium="selectedLayer.Medium")
      span.label &nbsp;&nbsp; {{ selectedLayer.Medium.name }} &nbsp;
      span.label.separator {{ $t("|") }}
      span.label W:{{ selectedLayer.width }} H:{{ selectedLayer.height }} px
      span.label.muted(v-if='boxResizingCoordinates') &nbsp;/ {{ boxResizingCoordinates.width }}x{{ boxResizingCoordinates.height }}
      span.label.separator {{ $t("|") }}
      span.label X:{{ selectedLayer.anchorX }} Y:{{ selectedLayer.anchorY }} px
      span.label.muted(v-if='boxResizingCoordinates') &nbsp;/ X:{{ boxResizingCoordinates.anchorX }} Y:{{ boxResizingCoordinates.anchorY }}
</template>

<script>
import Vue from 'vue'
import mediaUtils from '../Common/mediaUtils.mixin'
import MediumIcon from '../Common/MediumIcon'

import Viewport from './LayoutEditor/Viewport'
import Guides from './LayoutEditor/Guides'
import LayersPalette from './LayoutEditor/LayersPalette'
import commonLayoutEditor from './LayoutEditor/commonLayoutEditor.mixin'

export default {
  props: ['mediumId'],
  mixins: [mediaUtils, commonLayoutEditor],
  components: {
    Viewport,
    Guides,
    LayersPalette,
    MediumIcon
  },
  created () {
    const that = this
    window.addEventListener('resize', function () {
      that.__calculateSceneConstrains()
      that.recalculateGuides()
    })
  },
  async mounted () {
    document.documentElement.requestFullscreen()
    await this.loadData()
  },
  beforeDestroy () {
    if (window.innerHeight === screen.height) return document.exitFullscreen()
  },
  data () {
    return {
      errors: [],
      scale: 1,
      viewParams: {
        snapToGuides: true,
        dimunfocused: false,
        snapDistance: 30,
        minimumRightColumnWidth: 250,
        highQualityPreview: false
      },
      guides: {
        horizontal: [],
        vertical: []
      },
      playListWithContentSimple: undefined,
      selectedLayer: undefined,
      boxResizingCoordinates: undefined,
      hiddenLayers: [],
      lockedLayers: [],
      divider: {
        dragStartXPosition: 0,
        dragEndXPosition: 0,
        value: 0
      }
    }
  },
  methods: {
    // view flamboyance
    toggleColumns () {
      this.divider.value = this.divider.value !== 0 && this.$refs.page.offsetWidth - this.divider.value < this.viewParams.minimumRightColumnWidth ? 0 : this.$refs.page.offsetWidth - 10
      this.$nextTick(_ => {
        this.__calculateSceneConstrains()
        this.recalculateGuides()
      })
    },
    toggleFullScreen () {
      if (window.innerHeight === screen.height) return document.exitFullscreen()
      document.documentElement.requestFullscreen()
    },
    getLeftColumnStyle () {
      if (this.divider.value === 0) return 'width: 85vw;'
      // right column less than 100px width does not make sense
      if (this.$refs.page.offsetWidth - this.divider.value < this.viewParams.minimumRightColumnWidth) {
        return `width: ${this.$refs.page.offsetWidth - 6}px;`
      }
      return `width: ${this.divider.value}px;`
    },
    getRightColumnStyle () {
      if (this.divider.value === 0) return 'width: 15vw;'
      if (this.$refs.page.offsetWidth - this.divider.value < this.viewParams.minimumRightColumnWidth) {
        return `width: 6px;`
      }
      return `width: ${this.$refs.page.offsetWidth - this.divider.value}px;`
    },
    dragDivider ($event) {
      if ($event.screenX > 0) {
        this.divider.value = $event.screenX
      }
      this.$nextTick(_ => {
        this.recalculateGuides()
        this.__calculateSceneConstrains()
      })
    },
    // end view flamboyance
    selectLayerInLayersPalette ({ layer, $event }) {
      this.selectLayer(layer, $event)
    },
    toggleLayerLocked (layer) {
      const index = this.lockedLayers.findIndex(l => l.id === layer.id)
      if (index < 0) {
        if (this.selectedLayer.id === layer.id) this.selectedLayer = undefined
        this.lockedLayers.push(layer)
      } else {
        this.lockedLayers.splice(index, 1)
      }
    },
    toggleLayerHidden (layer) {
      const index = this.hiddenLayers.findIndex(l => l.id === layer.id)
      if (index < 0) {
        this.hiddenLayers.push(layer)
      } else {
        this.hiddenLayers.splice(index, 1)
      }
    },
    recalculateGuides () {
      this.guides = {
        horizontal: [],
        vertical: []
      }
      this.guides.horizontal.push({ screen: 0, real: 0, viewport: true }, { screen: this.playListWithContentSimple.playListLayoutHeight * this.scale, real: this.playListWithContentSimple.playListLayoutHeight, viewport: true })
      this.guides.vertical.push({ screen: 0, real: 0, viewport: true }, { screen: this.playListWithContentSimple.playListLayoutWidth * this.scale, real: this.playListWithContentSimple.playListLayoutWidth, viewport: true })
      if (this.viewParams.snapToGuides === true) {
        for (const layer of this.playListWithContentSimple.PlayListItems) {
          const screenCoordinates = this.__getZoneScreenCoordinates(layer)
          this.guides.horizontal.push(
            { screen: screenCoordinates.top, real: layer.anchorY },
            { screen: screenCoordinates.top + screenCoordinates.height, real: layer.anchorY + layer.height }
          )
          this.guides.vertical.push(
            { screen: screenCoordinates.left, real: layer.anchorX },
            { screen: screenCoordinates.left + screenCoordinates.width, real: layer.anchorX + layer.width }
          )
        }
      }
    },
    async boxResizedEventHandler (data) {
      this.boxResizingCoordinates = undefined
      await this.patchPlayItem(
        data.id,
        this.__getZoneRealCoordinates(data.box, data.resizeDirection)
      )
    },
    __calculateSceneConstrains () {
      if (!this.$refs.viewportcontainer) return
      const viewportHTMLTag = this.$refs.viewportcontainer
      const scaleWidth = (viewportHTMLTag.offsetWidth - 20) / this.playListWithContentSimple.playListLayoutWidth
      const scaleHeight = (viewportHTMLTag.offsetHeight - 20) / this.playListWithContentSimple.playListLayoutHeight
      this.scale = scaleHeight < scaleWidth ? scaleHeight : scaleWidth
    },
    __getZoneRealCoordinates (layerScreenCoordinates, resizeDirection) {
      const coordinates = {
        width: resizeDirection === 'rectangle' ? this.selectedLayer.width : Math.round(layerScreenCoordinates.width / this.scale),
        height: resizeDirection === 'rectangle' ? this.selectedLayer.height : Math.round(layerScreenCoordinates.height / this.scale),
        anchorX: Math.round(layerScreenCoordinates.left / this.scale),
        anchorY: Math.round(layerScreenCoordinates.top / this.scale)
      }
      return this.viewParams.snapToGuides ? this.__snapAdjust(coordinates, resizeDirection) : coordinates
    },
    __getZoneScreenCoordinates (layerRealCoordinates) {
      return {
        width: layerRealCoordinates.width ? layerRealCoordinates.width * this.scale : this.playListWithContentSimple.playListLayoutWidth * this.scale,
        height: layerRealCoordinates.height ? layerRealCoordinates.height * this.scale : this.playListWithContentSimple.playListLayoutHeight * this.scale,
        left: layerRealCoordinates.anchorX * this.scale,
        top: layerRealCoordinates.anchorY * this.scale
      }
    },
    __snapAdjust (coordinates, resizeDirection) {
      const coordinatesToAdjustTo = this.__findClosestGuides(coordinates)
      const differenceTop = coordinatesToAdjustTo.top - coordinates.anchorY
      const differenceBottom = coordinatesToAdjustTo.bottom - (coordinates.anchorY + coordinates.height)
      const differenceLeft = coordinatesToAdjustTo.left - coordinates.anchorX
      const differenceRight = coordinatesToAdjustTo.right - (coordinates.anchorX + coordinates.width)
      // top adjust
      if (Math.abs(differenceTop) < this.viewParams.snapDistance && Math.abs(differenceTop) > 0) {
        coordinates.anchorY += differenceTop
        if (resizeDirection !== 'rectangle') {
          coordinates.height -= differenceTop
        }
      }
      // bottom adjust
      if (Math.abs(differenceBottom) < this.viewParams.snapDistance && Math.abs(differenceBottom) > 0) {
        if (resizeDirection === 'rectangle' && Math.abs(differenceBottom) < Math.abs(differenceTop)) {
          coordinates.anchorY += differenceBottom
        } else if (resizeDirection !== 'rectangle') {
          coordinates.height += differenceBottom
        }
      }
      // left adjust
      if (Math.abs(differenceLeft) < this.viewParams.snapDistance && Math.abs(differenceLeft) > 0) {
        coordinates.anchorX += differenceLeft
        if (resizeDirection !== 'rectangle') {
          coordinates.width -= differenceLeft
        }
      }
      // right adjust
      if (Math.abs(differenceRight) < this.viewParams.snapDistance && Math.abs(differenceRight) > 0) {
        if (resizeDirection === 'rectangle' && Math.abs(differenceRight) < Math.abs(differenceLeft)) {
          coordinates.anchorX += differenceRight
        } else if (resizeDirection !== 'rectangle') {
          coordinates.width += differenceRight
        }
      }
      return coordinates
    },
    __findClosestGuides (coordinates) {
      // closest top
      let closestGuideHorizontalTop = this.guides.horizontal[0]
      let mindistanceTop = Math.abs(closestGuideHorizontalTop.real - coordinates.anchorY)
      for (const guide of this.guides.horizontal) {
        const guideDistance = Math.abs(guide.real - coordinates.anchorY)
        if (guideDistance < mindistanceTop) {
          mindistanceTop = guideDistance
          closestGuideHorizontalTop = guide
        }
      }
      // closest bottom
      let closestGuideHorizontalBottom = this.guides.horizontal[0]
      let mindistanceBottom = Math.abs(closestGuideHorizontalBottom.real - (coordinates.anchorY + coordinates.height))
      for (const guide of this.guides.horizontal) {
        const guideDistance = Math.abs(guide.real - (coordinates.anchorY + coordinates.height))
        if (guideDistance < mindistanceBottom) {
          mindistanceBottom = guideDistance
          closestGuideHorizontalBottom = guide
        }
      }
      // closest left
      let closestGuideVerticalLeft = this.guides.vertical[0]
      let mindistanceLeft = Math.abs(closestGuideVerticalLeft.real - coordinates.anchorX)
      for (const guide of this.guides.vertical) {
        const guideDistance = Math.abs(guide.real - coordinates.anchorX)
        if (guideDistance < mindistanceLeft) {
          mindistanceLeft = guideDistance
          closestGuideVerticalLeft = guide
        }
      }
      // closest right
      let closestGuideVerticalRight = this.guides.vertical[0]
      let mindistanceRight = Math.abs(closestGuideVerticalRight.real - (coordinates.anchorX + coordinates.width))
      for (const guide of this.guides.vertical) {
        const guideDistance = Math.abs(guide.real - (coordinates.anchorX + coordinates.width))
        if (guideDistance < mindistanceRight) {
          mindistanceRight = guideDistance
          closestGuideVerticalRight = guide
        }
      }
      return {
        top: closestGuideHorizontalTop.real,
        bottom: closestGuideHorizontalBottom.real,
        left: closestGuideVerticalLeft.real,
        right: closestGuideVerticalRight.real
      }
    },
    getVieportStyle () {
      if (!this.playListWithContentSimple) return
      return `width: ${this.playListWithContentSimple.playListLayoutWidth * this.scale}px; height: ${this.playListWithContentSimple.playListLayoutHeight * this.scale}px;`
    },
    redrawBoundingBox () {
      this.$refs.viewport.redrawBoundingBox()
    },
    async patchPlayItem (playItemId, data) {
      await Vue.axios
        .patch(`PlayListItem/${playItemId}`, data)
      await this.loadData()
      this.selectedLayer = this.playListWithContentSimple.PlayListItems.find(pli => pli.id === playItemId)
    },
    async loadData () {
      this.playListWithContentSimple = {
        PlayListItems: []
      }
      const playListMedium = this.$store.state.Medium.media_list.find(m => m.id === this.mediumId)
      this.playListWithContentSimple = await this.$store.dispatch('Medium/getPlaylistContentSimple', playListMedium)
      this.playListWithContentSimple.PlayListItems.sort((a, b) => (a.order > b.order) ? -1 : 1)

      this.$nextTick(_ => {
        this.__calculateSceneConstrains()
        this.recalculateGuides()
      })
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-fullscreen-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000001;
  background-color: $--page-background;
  .left-column {
    overflow: hidden;
  }
  .top-bar {
    height: 40px;
    display: flex;
    flex-direction: row;
    border-bottom: $--border-extra-light;
    .right-column {
      display: flex;
      flex-direction: row-reverse;
      .first {
        margin-right: 10px;
      }
    }
    .left-column {
      text-align: center;
    }
  }
  .container-stage {
    height: calc(100vh - 40px - 30px);
    width: 100%;
    display: flex;
    .left-column {
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: $--border-extra-light;
      .viewport {
        box-shadow:inset 0px 0px 0px 1px rgba(#999999, 0.3);
        position: relative;
        background-color: mix($--page-background, #000000, 50%);
        overflow: hidden;
        .layer {
          position: absolute;
          // box-shadow:inset 0px 0px 0px 1px rgba(#999999, 0.3);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          &.dimunfocused {
            opacity: 0.5;
          }
          &.focused {
            opacity: 1;
          }
        }
      }
    }
  }
  .status-bar {
    height: 30px;
    padding-left: 20px;
    width: 100%;
    border-top: $--border-extra-light;
    display: flex;
    .el-form-item__label, .label {
      font-size: $--font-size-base;
    }
    .label {
      padding-top: 5px;
      &.separator {
        padding-left: 15px;
        padding-right: 15px;
        opacity: 0.3;
      }
    }
  }
  .red {
    border: 1px solid red;
  }
  .green {
    border: 1px solid green;
  }
  .blue {
    border: 1px solid blue;
  }
  .divider {
    height: 100%;
    width: 2px;
    background-color: rgba($--color-text-placeholder, 0.0);
    cursor: ew-resize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/LayoutEditorFullScreen.vue